// auth.js
export const LOGOUT = 'LOGOUT';
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const ACCEPT_COOKIES = 'ACCEPT_COOKIES';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const UPDATE_USER = 'UPDATE_USER';

export const USERS_FETCH_ALL = 'USERS_FETCH_ALL';
export const USERS_REMOVE = 'USERS_REMOVE';
export const USERS_STUDY = 'USERS_STUDY';
export const USERS_CLEAR = 'USERS_CLEAR';
export const USERS_CLEAR_ALL = 'USERS_CLEAR_ALL';
export const USERS_UPDATE = 'USERS_UPDATE';
export const USERS_CREATE = 'USERS_CREATE';
export const USERS_FIND = 'USERS_FIND';
export const USERS_STATS = 'USERS_STATS';
export const USERS_CLEAR_STATS = 'USERS_CLEAR_STATS';

export const COURSES_FETCH_ALL = 'COURSES_FETCH_ALL';
export const COURSES_REMOVE = 'COURSES_REMOVE';
export const COURSES_CLEAR = 'COURSES_CLEAR';
export const COURSES_CLEAR_ALL = 'COURSES_CLEAR_ALL';
export const COURSES_UPDATE = 'COURSES_UPDATE';
export const COURSES_CREATE = 'COURSES_CREATE';
export const COURSES_FIND = 'COURSES_FIND';

export const LESSONS_FETCH_ALL = 'LESSONS_FETCH_ALL';
export const LESSONS_REMOVE = 'LESSONS_REMOVE';
export const LESSONS_CLEAR = 'LESSONS_CLEAR';
export const LESSONS_CLEAR_ALL = 'LESSONS_CLEAR_ALL';
export const LESSONS_UPDATE = 'LESSONS_UPDATE';
export const LESSONS_CREATE = 'LESSONS_CREATE';
export const LESSONS_FIND = 'LESSONS_FIND';

export const TESTS_FETCH_ALL = 'TESTS_FETCH_ALL';
export const TESTS_REMOVE = 'TESTS_REMOVE';
export const TESTS_CLEAR = 'TESTS_CLEAR';
export const TESTS_CLEAR_ALL = 'TESTS_CLEAR_ALL';
export const TESTS_UPDATE = 'TESTS_UPDATE';
export const TESTS_CREATE = 'TESTS_CREATE';
export const TESTS_FIND = 'TESTS_FIND';

export const QUESTIONS_FETCH_ALL = 'QUESTIONS_FETCH_ALL';
export const QUESTIONS_REMOVE = 'QUESTIONS_REMOVE';
export const QUESTIONS_CLEAR = 'QUESTIONS_CLEAR';
export const QUESTIONS_CLEAR_ALL = 'QUESTIONS_CLEAR_ALL';
export const QUESTIONS_UPDATE = 'QUESTIONS_UPDATE';
export const QUESTIONS_CREATE = 'QUESTIONS_CREATE';
export const QUESTIONS_FIND = 'QUESTIONS_FIND';

export const PAGES_FIND = 'PAGES_FIND';
export const PAGE_SELECTED = 'PAGE_SELECTED';
export const PAGES_SET_BREADCRUMBS = 'PAGES_SET_BREADCRUMBS';
export const PAGES_SET_CONTROLS = 'PAGES_SET_CONTROLS';
export const PAGES_UPDATE = 'PAGES_UPDATE';
export const PAGE_CLEAR = 'PAGE_CLEAR';
export const PAGES_UPDATE_PAGE_INFO = 'PAGES_UPDATE_PAGE_INFO';
export const LOADING_START = 'LOADING_START';
export const LOADING_STOP = 'LOADING_STOP';

export const FETCH_COURSES_SUCCESS = 'FETCH_COURSES_SUCCESS';
export const FETCH_COURSES_FAILURE = 'FETCH_COURSES_FAILURE';
export const FETCH_ONE_COURSE_SUCCESS = 'FETCH_ONE_COURSE_SUCCESS';
export const FETCH_ONE_COURSE_FAILURE = 'FETCH_ONE_COURSE_FAILURE';
export const CLEAR_COURSE = 'CLEAR_COURSE';
export const ADD_COURSE_SUCCESS = 'ADD_COURSE_SUCCESS';
export const ADD_COURSE_FAILURE = 'ADD_COURSE_FAILURE';
export const UPDATE_COURSE_SUCCESS = 'UPDATE_COURSE_SUCCESS';
export const UPDATE_COURSE_FAILURE = 'UPDATE_COURSE_FAILURE';
export const REMOVE_COURSE_SUCCESS = 'REMOVE_COURSE_SUCCESS';
export const REMOVE_COURSE_FAILURE = 'REMOVE_COURSE_FAILURE';

export const FETCH_PARTNERS_SUCCESS = 'FETCH_PARTNERS_SUCCESS';
export const FETCH_PARTNERS_FAILURE = 'FETCH_PARTNERS_FAILURE';
export const FETCH_ONE_PARTNER_SUCCESS = 'FETCH_ONE_PARTNER_SUCCESS';
export const FETCH_ONE_PARTNER_FAILURE = 'FETCH_ONE_PARTNER_FAILURE';
export const CLEAR_PARTNER = 'CLEAR_PARTNER';
export const ADD_PARTNER_SUCCESS = 'ADD_PARTNER_SUCCESS';
export const ADD_PARTNER_FAILURE = 'ADD_PARTNER_FAILURE';
export const UPDATE_PARTNER_SUCCESS = 'UPDATE_PARTNER_SUCCESS';
export const UPDATE_PARTNER_FAILURE = 'UPDATE_PARTNER_FAILURE';
export const REMOVE_PARTNER_SUCCESS = 'REMOVE_PARTNER_SUCCESS';
export const REMOVE_PARTNER_FAILURE = 'REMOVE_PARTNER_FAILURE';

export const FETCH_TESTS_SUCCESS = 'FETCH_TESTS_SUCCESS';
export const FETCH_TEST_QUESTIONS_SUCCESS = 'FETCH_TEST_QUESTIONS_SUCCESS';
export const FETCH_TESTS_FAILURE = 'FETCH_TESTS_FAILURE';
export const FETCH_TEST_QUESTIONS_FAILURE = 'FETCH_TEST_QUESTIONS_FAILURE';
export const FETCH_ONE_TEST_SUCCESS = 'FETCH_ONE_TEST_SUCCESS';
export const FETCH_ONE_TEST_FAILURE = 'FETCH_ONE_TEST_FAILURE';
export const CLEAR_TEST = 'CLEAR_TEST';
export const ADD_TEST_SUCCESS = 'ADD_TEST_SUCCESS';
export const ADD_TEST_FAILURE = 'ADD_TEST_FAILURE';
export const UPDATE_TEST_SUCCESS = 'UPDATE_TEST_SUCCESS';
export const UPDATE_TEST_FAILURE = 'UPDATE_TEST_FAILURE';
export const REMOVE_TEST_SUCCESS = 'REMOVE_TEST_SUCCESS';
export const REMOVE_TEST_FAILURE = 'REMOVE_TEST_FAILURE';
export const CHECK_TEST_SUCCESS = 'CHECK_TEST_SUCCESS';
export const CHECK_TEST_FAILURE = 'CHECK_TEST_FAILURE';

export const FETCH_LESSON_TESTS_SUCCESS = 'FETCH_LESSON_TESTS_SUCCESS';
export const FETCH_LESSON_TESTS_FAILURE = 'FETCH_LESSON_TESTS_FAILURE';

export const FETCH_COURSE_TESTS_SUCCESS = 'FETCH_COURSE_TESTS_SUCCESS';
export const FETCH_COURSE_TESTS_FAILURE = 'FETCH_COURSE_TESTS_FAILURE';

export const FETCH_LESSONS_SUCCESS = 'FETCH_LESSONS_SUCCESS';
export const FETCH_LESSONS_FAILURE = 'FETCH_LESSONS_FAILURE';
export const FETCH_ONE_LESSON_SUCCESS = 'FETCH_ONE_LESSON_SUCCESS';
export const FETCH_ONE_LESSON_FAILURE = 'FETCH_ONE_LESSON_FAILURE';
export const CLEAR_LESSON = 'CLEAR_LESSON';
export const ADD_LESSON_SUCCESS = 'ADD_LESSON_SUCCESS';
export const ADD_LESSON_FAILURE = 'ADD_LESSON_FAILURE';
export const UPDATE_LESSON_SUCCESS = 'UPDATE_LESSON_SUCCESS';
export const UPDATE_LESSON_FAILURE = 'UPDATE_LESSON_FAILURE';
export const REMOVE_LESSON_SUCCESS = 'REMOVE_LESSON_SUCCESS';
export const REMOVE_LESSON_FAILURE = 'REMOVE_LESSON_FAILURE';
export const STUDY_LESSON_SUCCESS = 'STUDY_LESSON_SUCCESS';
export const STUDY_LESSON_FAILURE = 'STUDY_LESSON_FAILURE';

export const FETCH_QUESTIONS_SUCCESS = 'FETCH_QUESTIONS_SUCCESS';
export const FETCH_QUESTIONS_FAILURE = 'FETCH_QUESTIONS_FAILURE';
export const FETCH_ONE_QUESTION_SUCCESS = 'FETCH_ONE_QUESTION_SUCCESS';
export const FETCH_ONE_QUESTION_FAILURE = 'FETCH_ONE_QUESTION_FAILURE';
export const CLEAR_QUESTION = 'CLEAR_QUESTION';
export const ADD_QUESTION_SUCCESS = 'ADD_QUESTION_SUCCESS';
export const ADD_QUESTION_FAILURE = 'ADD_QUESTION_FAILURE';
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
export const UPDATE_QUESTION_FAILURE = 'UPDATE_QUESTION_FAILURE';
export const REMOVE_QUESTION_SUCCESS = 'REMOVE_QUESTION_SUCCESS';
export const REMOVE_QUESTION_FAILURE = 'REMOVE_QUESTION_FAILURE';

export const FETCH_VARIANTS_SUCCESS = 'FETCH_VARIANTS_SUCCESS';
export const FETCH_QUESTION_VARIANTS_SUCCESS = 'FETCH_QUESTION_VARIANTS_SUCCESS';
export const FETCH_QUESTION_VARIANTS_FAILURE = 'FETCH_QUESTION_VARIANTS_FAILURE';
export const FETCH_VARIANTS_FAILURE = 'FETCH_VARIANTS_FAILURE';
export const FETCH_ONE_VARIANT_SUCCESS = 'FETCH_ONE_VARIANT_SUCCESS';
export const FETCH_ONE_VARIANT_FAILURE = 'FETCH_ONE_VARIANT_FAILURE';
export const CLEAR_VARIANT = 'CLEAR_VARIANT';
export const ADD_VARIANT_SUCCESS = 'ADD_VARIANT_SUCCESS';
export const ADD_VARIANT_FAILURE = 'ADD_VARIANT_FAILURE';
export const UPDATE_VARIANT_SUCCESS = 'UPDATE_VARIANT_SUCCESS';
export const UPDATE_VARIANT_FAILURE = 'UPDATE_VARIANT_FAILURE';
export const REMOVE_VARIANT_SUCCESS = 'REMOVE_VARIANT_SUCCESS';
export const REMOVE_VARIANT_FAILURE = 'REMOVE_VARIANT_FAILURE';

export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const FETCH_ONE_USER_SUCCESS = 'FETCH_ONE_USER_SUCCESS';
export const FETCH_ONE_USER_FAILURE = 'FETCH_ONE_USER_FAILURE';
export const CLEAR_USER = 'CLEAR_USER';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const REMOVE_USER_SUCCESS = 'REMOVE_USER_SUCCESS';
export const REMOVE_USER_FAILURE = 'REMOVE_USER_FAILURE';

export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE';

export const SHOW_LOGIN_SUCCESS = 'SHOW_LOGIN_SUCCESS';
export const SHOW_LOGIN_FAILURE = 'SHOW_LOGIN_FAILURE';
export const CLOSE_LOGIN_SUCCESS = 'CLOSE_LOGIN_SUCCESS';
export const CLOSE_LOGIN_FAILURE = 'CLOSE_LOGIN_FAILURE';
export const SHOW_REGISTER_SUCCESS = 'SHOW_REGISTER_SUCCESS';
export const SHOW_REGISTER_FAILURE = 'SHOW_REGISTER_FAILURE';
export const CLOSE_REGISTER_SUCCESS = 'CLOSE_REGISTER_SUCCESS';
export const CLOSE_REGISTER_FAILURE = 'CLOSE_REGISTER_FAILURE';
export const INIT_LOGIN_SUCCESS = 'INIT_LOGIN_SUCCESS';
export const INIT_REGISTER_SUCCESS = 'INIT_REGISTER_SUCCESS';

export const FETCH_COMMON_INFO_SUCCESS = 'FETCH_COMMON_INFO_SUCCESS';
export const FETCH_COMMON_INFO_FAILURE = 'FETCH_COMMON_INFO_FAILURE';

export const FETCH_PAGE_SUCCESS = 'FETCH_PAGE_SUCCESS';
export const FETCH_PAGE_FAILURE = 'FETCH_PAGE_FAILURE';
export const UPDATE_PAGE_SUCCESS = 'UPDATE_PAGE_SUCCESS';
export const UPDATE_PAGE_FAILURE = 'UPDATE_PAGE_FAILURE';
export const UPDATE_PAGE_INFO_SUCCESS = 'UPDATE_PAGE_INFO_SUCCESS';
export const SET_BREADCRUMBS_SUCCESS = 'SET_BREADCRUMBS_SUCCESS';
export const SET_BREADCRUMBS_FAILURE = 'SET_BREADCRUMBS_FAILURE';

// lang.js
export const SET_LOCALE = 'SET_LOCALE';
